import css from "./card.module.css"
import {JSX} from "solid-js";

export default function Card(props: { children: JSX.Element }) {
    return (
        <div class={css.card}>
            {props.children}
        </div>
    )
}